import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { IrpSearchProvider } from './context/irp-search-context';
import { IrpSearchComponent } from './irp-search-component';

export function IrpSearchFactory() {
    return (
        <BaseLayoutFactory>
            <IrpSearchProvider>
                <IrpSearchComponent />
            </IrpSearchProvider>
        </BaseLayoutFactory>
    );
}
